import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { getCardUrl } from "@/utils/utils";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Table,
    message,
    Row,
    Col,
    Card,
    Modal,
    Select,
    Button,
    InputNumber,
    Pagination,
    DatePicker,
    Spin,
    Empty,
    Input,
    Form,
    Icon,
    notification,
} from "antd";
import HandDetail from "@/pages/commom/HandDetail";
import HandDetailOfc from "@/pages/commom/HandDetailOfc";
import { kindList, squidTypeList, } from "@/utils/constant";
let timer
let key = `open${Date.now()}`;

let kindListFilter = kindList.filter(
    (item) => item.value !== 3 && item.value !== 5
);

// 表单数据
const formData = {
    begin_page: undefined,
    end_page: undefined,
}

export default class TableRoundRecordList extends React.Component {
    state = {
        loading: false, // 是否加载中
        detailLoading: false, // 详情是否加载中
        exportLoading: false, // 导出是否加载中
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        showExport: false, // 是否显示导出弹窗
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            sb: undefined,
            match_type: undefined,
            match_name: undefined,
            game_kind: undefined,
            id_key: undefined,
            id_value: undefined,
            date: [],
        },
        detailQueryParams: {
            // 详情查询参数
            page: 1,
            limit: 1,
            total: 0,
            uid: undefined,
            player_num: undefined,
            pot: undefined,
        },
        kindList: kindListFilter, // 游戏类型列表
        squidTypeList: squidTypeList, // 鱿鱼模式
        blindLeveList: [
            // 盲注级别
            { value: "0.1", label: "0.1" },
            { value: "0.2", label: "0.2" },
            { value: "0.5", label: "0.5" },
            { value: "1", label: "1" },
            { value: "2", label: "2" },
            { value: "5", label: "5" },
            { value: "10", label: "10" },
            { value: "20", label: "20" },
            { value: "25", label: "25" },
            { value: "50", label: "50" },
            { value: "100+", label: "100+" },
        ],
        matchTypeList: [
            // 牌局所属
            { value: "club", label: this.props.language["clubTableRound"] },
            { value: "union", label: this.props.language["unionTableRound"] },
            { value: "super_union", label: this.props.language["superUnionTableRound"] },
        ],
        idTypeList: [
            // id类型
            { value: "match", label: this.props.language["gambleId"] },
            { value: "user", label: this.props.language["createOwnerUid"] },
            { value: "club", label: this.props.language["clubId"] },
            { value: "union", label: this.props.language["unionId"] },
        ],
        data: [], // 表格数据
        selectedData: {}, // 选中的表格数据
        handCardData: {}, // 手牌详情
        recordData: {}, // 战绩详情
        playerData: [], // 玩家列表
        formData: { ...formData }, // 表单数据
    };

    componentDidMount () {
        if (Cookie.get("unionType") !== "super_union") {
            this.setState({
                idTypeList: this.state.idTypeList.filter(
                    (item) => item.value !== "union"
                ),
            });
        }
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/union_game_list", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取手牌详情数据
     */
    fetchHandCardData = () => {
        this.setState({ detailLoading: true });
        axios
            .get("/v1/api/union_game_detail", {
                params: {
                    ...this.state.detailQueryParams,
                    mid: this.state.selectedData.mid,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        total: res.count || 0,
                    },
                    handCardData: res.data || {},
                });
            });
    };

    /**
     * 获取战绩详情数据
     */
    fetchRecodData = () => {
        this.setState({ detailLoading: true });
        axios
            .get(
                `/v1/api/union_game_record_detail/${this.state.selectedData.mid}`
            )
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    recordData: res.data || {},
                });
            });
    };

    /**
     * 获取玩家列表数据
     */
    fetchPlayerData = () => {
        this.setState({ detailLoading: true });
        axios
            .get(`/v1/api/union_game_member_list/${this.state.selectedData.mid}`)
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    playerData: res.data || [],
                });
            });
    };

    /**
     * 改变数据分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "data") {
            // 数据分页
            this.setState(
                {
                    queryParams: {
                        ...this.state.queryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchData()
            );
        } else if (type === "handCard") {
            // 手牌详情数据
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchHandCardData()
            );
        }
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value, type) => {
        if (type === "handCard") {
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => this.fetchHandCardData()
            );
        } else {
            this.setState({
                queryParams: { ...this.state.queryParams, page: 1, [key]: value },
            });
        }
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    sb: undefined,
                    match_type: undefined,
                    match_name: undefined,
                    game_kind: undefined,
                    id_key: undefined,
                    id_value: undefined,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    /**
     * 显示弹窗
     */
    handleShow = (item, type) => {
        if (type === "handCard") {
            // 手牌详情
            this.setState(
                {
                    title: this.props.language["handDetail"],
                    type,
                    show: true,
                    selectedData: { ...item },
                    handCardData: {},
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        uid: undefined,
                        player_num: undefined,
                        pot: undefined,
                    },
                },
                () => this.fetchHandCardData()
            );
        } else if (type === "record") {
            // 战绩详情
            this.setState(
                {
                    title: this.props.language["recordDetail"],
                    type,
                    show: true,
                    selectedData: { ...item },
                    recordData: {},
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                    },
                },
                () => this.fetchRecodData()
            );
        } else if (type === "player") {
            // 玩家列表
            this.setState(
                {
                    title: this.props.language["playerList"],
                    type,
                    show: true,
                    selectedData: { ...item },
                    playerData: [],
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                    },
                },
                () => this.fetchPlayerData()
            );
        } else if (type === "export") {
            // 导出
            this.setState({
                title: this.props.language["selectPageExport"],
                type,
                showExport: true,
            });
        }
    };

    /**
     * 关闭弹窗
     */
    handleClose = () => {
        this.formRef.props.form.resetFields();
        this.setState({ showExport: false, formData: { ...formData } });
    }

    /**
     * 获取导出的数据路径key
     */
    handleGetExportKey = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                axios
                    .get("/v1/api/export_union_game_list", {
                        params: {
                            ...this.state.queryParams,
                            begin_time:
                                this.state.queryParams.date[0] &&
                                this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                            end_time:
                                this.state.queryParams.date[1] &&
                                this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                            begin_page: values.begin_page,
                            end_page: values.end_page,
                            total: undefined,
                            date: undefined,
                        },
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            this.handleClose();
                            notification.open({
                                key,
                                duration: 0,
                                message: this.props.language["hint"],
                                description: this.props.language["exportLoaddingMessage"],
                                icon: <Icon type="loading" style={{ color: '#108ee9' }} />,
                                onClose: () => {
                                    if (timer) clearInterval(timer);
                                    timer = undefined;
                                    this.setState({ exportLoading: false });
                                }
                            });
                            if (!timer) {
                                this.handleExport(res.file_id);
                                timer = setInterval(() => {
                                    this.handleExport(res.file_id);
                                }, 2000);
                            }
                        }

                    });
            }
        });
    };

    /**
     * 根据key进行导出数据
     */
    handleExport = (file_id) => {
        this.setState({ exportLoading: true });
        axios.get('/v1/api/get_export_union_game_list_url', {
            params: {
                file_id,
            },
        })
            .then((res) => {
                if (res.url) {
                    notification.close(key);
                    if (timer) clearInterval(timer);
                    timer = undefined;
                    this.setState({ exportLoading: false });
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    }

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["searchTypePlaceholder"]}
                        value={this.state.queryParams.id_key}
                        onChange={(value) => this.handleSetQueryParamsData("id_key", value)}
                    >
                        {this.state.idTypeList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["searchContentPlaceholder"]}
                        value={this.state.queryParams.id_value}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("id_value", value)
                        }
                    />
                    <Input
                        maxLength={60}
                        allowClear
                        placeholder={this.props.language["gambleNamePlaceholder"]}
                        value={this.state.queryParams.match_name}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("match_name", e.target.value)
                        }
                    />
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["blindLevelPlaceholder"]}
                        value={this.state.queryParams.sb}
                        onChange={(value) => this.handleSetQueryParamsData("sb", value)}
                    >
                        {this.state.blindLeveList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["belongGamblePlaceholder"]}
                        value={this.state.queryParams.match_type}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("match_type", value)
                        }
                    >
                        {this.state.matchTypeList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["gameTypePlaceholder"]}
                        value={this.state.queryParams.game_kind}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("game_kind", value)
                        }
                    >
                        {this.state.kindList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={() => this.handleShow(null, "export")}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["createTime"]}
                            dataIndex="created_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["startTime"]}
                            dataIndex="begin_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleId"]}
                            dataIndex="mid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleName"]}
                            dataIndex="match_info"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["belongGamble"]}
                            dataIndex="founder_owner"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleType"]}
                            dataIndex="match_type_play"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["level"]}
                            dataIndex="sb_bb_ante"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["squidGame"]}
                            dataIndex=""
                            render={(item) =>
                                item.squid_conf ? (
                                    <p>
                                        {this.state.squidTypeList.find(
                                            (item2) => item2.value === item.squid_conf.mode
                                        ) ?
                                            this.state.squidTypeList.find(
                                                (item2) => item2.value === item.squid_conf.mode
                                            ).label : ''}
                                        ({item.squid_conf.bb / 2}BB)
                                    </p>
                                ) : (
                                    this.props.language["no"]
                                )
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sushiGame"]}
                            dataIndex=""
                            render={(item) =>
                                item.sushi_conf ? (
                                    <>
                                        <p>
                                            {item.sushi_conf.baseAnte}BB
                                            /
                                            {item.sushi_conf.seatAnte}BB
                                        </p>
                                    </>
                                ) : (
                                    this.props.language["no"]
                                )
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["seatNumber"]}
                            dataIndex="seat_num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalHand"]}
                            dataIndex="hands"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={320}
                            render={(item) => (
                                <>
                                    <Button
                                        type="default"
                                        onClick={() => this.handleShow(item, "handCard")}
                                    >
                                        {this.props.language["handDetail"]}
                                    </Button>
                                    <Button
                                        className="ml10"
                                        type="default"
                                        onClick={() => this.handleShow(item, "record")}
                                    >
                                        {this.props.language["recordDetail"]}
                                    </Button>
                                    <Button
                                        className="ml10"
                                        type="default"
                                        onClick={() => this.handleShow(item, "player")}
                                    >
                                        {this.props.language["playerList"]}
                                    </Button>
                                </>
                            )}
                        />
                    </Table>
                    <Pagination
                        className="pagination"
                        showQuickJumper
                        showSizeChanger
                        size={isMobileDevice() ? 'small' : ''}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        pageSizeOptions={["10", "20", "30", "40"]}
                        current={this.state.queryParams.page}
                        pageSize={this.state.queryParams.limit}
                        total={this.state.queryParams.total}
                        onChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize }, "data")
                        }
                        onShowSizeChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize }, "data")
                        }
                    />
                </div>

                {/* 导出弹窗 */}
                <ExportFormModal
                    {...this.props}
                    visible={this.state.showExport}
                    type={this.state.type}
                    title={this.state.title}
                    formData={this.state.formData}
                    queryParams={this.state.queryParams}
                    onOk={this.handleGetExportKey}
                    onCancel={this.handleClose}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />

                {/* 详情弹窗 */}
                <DetailModal
                    {...this.props}
                    visible={this.state.show}
                    title={this.state.title}
                    type={this.state.type}
                    loading={this.state.detailLoading}
                    pagination={{
                        showTotal: (total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                        showQuickJumper: true,
                        current: this.state.detailQueryParams.page,
                        pageSize: this.state.detailQueryParams.limit,
                        total: this.state.detailQueryParams.total,
                        size: isMobileDevice() ? 'small' : '',
                    }}
                    selectedData={this.state.selectedData}
                    recordData={this.state.recordData}
                    playerData={this.state.playerData}
                    handCardData={this.state.handCardData}
                    detailQueryParams={this.state.detailQueryParams}
                    handleSetQueryParamsData={this.handleSetQueryParamsData}
                    onCancel={() => this.setState({ show: false })}
                    onChange={(current, pageSize) =>
                        this.hanldeChangePage({ current, pageSize }, "handCard")
                    }
                />
            </div>
        );
    }
}

/**
 * 导出弹窗
 */
const ExportFormModal = Form.create({ name: "form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue, setFieldsValue } =
                this.props.form;
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item label={this.props.language["startPage"]}>
                                {getFieldDecorator("begin_page", {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["startPageVerify"],
                                        },
                                    ],
                                    initialValue: this.props.formData.begin_page,
                                })(
                                    <InputNumber
                                        min={1}
                                        max={100000000}
                                        precision={0}
                                        placeholder={this.props.language["startPagePlaceholder"]}
                                    />
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["endPage"]}>
                                {getFieldDecorator("end_page", {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["endPageVerify"],
                                        },
                                        {
                                            validator: (_, value, callback) => {
                                                if (value < getFieldValue('begin_page')) {
                                                    return callback(this.props.language["exportEndPageTooLargeVerify"])
                                                } else {
                                                    return callback()
                                                }
                                            },
                                        },
                                    ],
                                    initialValue: this.props.formData.end_page,
                                })(
                                    <InputNumber
                                        min={1}
                                        max={100000000}
                                        precision={0}
                                        placeholder={this.props.language["endPagePlaceholder"]}
                                    />
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            );
        }
    }
);

/**
 * 详情弹窗
 */
class DetailModal extends React.Component {
    render () {
        let handCardTitle = (
            <div className='container-header p0'>
                {this.props.handCardData.hand_time && (
                    <>
                        <span>{this.props.title}</span>
                        <span>（{this.props.handCardData.id}）</span>
                        <span className="mr20">
                            {this.props.handCardData.hand_time
                                ? this.props.handCardData.hand_time
                                : ""}
                        </span>
                    </>
                )}
                <InputNumber
                    precision={0}
                    min={0}
                    max={100000000}
                    placeholder={this.props.language["playerIdPlaceholder"]}
                    value={this.props.detailQueryParams.uid}
                    onChange={(value) =>
                        this.props.handleSetQueryParamsData("uid", value, "handCard")
                    }
                />
                <InputNumber
                    precision={0}
                    min={0}
                    max={100000000}
                    placeholder={this.props.language["gamblingPartyNumberPlaceholder"]}
                    value={this.props.detailQueryParams.player_num}
                    onChange={(value) =>
                        this.props.handleSetQueryParamsData("player_num", value, "handCard")
                    }
                />
                <InputNumber
                    precision={2}
                    min={0}
                    max={100000000}
                    placeholder={this.props.language["cisternaBasalisPlaceholder"]}
                    value={this.props.detailQueryParams.pot}
                    onChange={(value) =>
                        this.props.handleSetQueryParamsData("pot", value, "handCard")
                    }
                />
            </div>
        );

        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={
                    this.props.type === "handCard" ? handCardTitle : this.props.title
                }
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: this.props.type === "handCard" ? '60vh' : '70vh',
                    overflowY: "auto",
                }}
                footer={
                    this.props.type === "handCard" ? (
                        <Pagination
                            {...this.props.pagination}
                            onChange={this.props.onChange}
                        />
                    ) : null
                }
            >
                <div className="container-content">
                    {/* 战绩详情 */}
                    {this.props.type === "record" && (
                        <>
                            <Card
                                title={
                                    <h3>
                                        {this.props.language["gambleStatistics"]}
                                    </h3>
                                }
                                type="inner"
                            >
                                <Table
                                    dataSource={
                                        this.props.recordData.statistical
                                            ? [this.props.recordData.statistical]
                                            : []
                                    }
                                    pagination={false}
                                    loading={this.props.loading}
                                    scroll={{ x: true }}
                                    rowKey={(record, index) => index}
                                >
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["buyIn"]}
                                        dataIndex="buy_in"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["serviceFee"]}
                                        dataIndex="fee"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["handNumber"]}
                                        dataIndex="hands"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["sumInsured"]}
                                        dataIndex="ins_buy"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["insureTimes"]}
                                        dataIndex="ins_num"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["insuranceProfit"]}
                                        dataIndex="ins_profit"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["profit"]}
                                        dataIndex="profit"
                                    />
                                </Table>
                            </Card>
                            <Card
                                className="mt20"
                                title={
                                    <h3>
                                        {this.props.language["playerStatistic"]}
                                    </h3>
                                }
                                type="inner"
                            >
                                <Table
                                    dataSource={
                                        this.props.recordData ? this.props.recordData.play_list : []
                                    }
                                    pagination={false}
                                    loading={this.props.loading}
                                    scroll={{ x: true }}
                                    rowKey={(record, index) => index}
                                >
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["playerId"]}
                                        dataIndex=""
                                        render={(item) => (
                                            <Link to={`/player_detail/${item.uid}/${item.club_id}`}>
                                                {item.uid || ''}
                                            </Link>
                                        )}
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["playerName"]}
                                        dataIndex="user_name"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["clubId"]}
                                        dataIndex=""
                                        render={(item) => (
                                            <Link to={`/club_detail/${item.club_id}`}>
                                                {item.club_id || ''}
                                            </Link>
                                        )}
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["clubName"]}
                                        dataIndex="club_name"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["unionId"]}
                                        dataIndex=""
                                        render={(item) => (
                                            <Link to={`/union_detail/${item.union_id}`}>
                                                {item.union_id || ''}
                                            </Link>
                                        )}
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["unionName"]}
                                        dataIndex="union_name"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["buyIn"]}
                                        dataIndex="buy_in"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["serviceFee"]}
                                        dataIndex="fee"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["handNumber"]}
                                        dataIndex="hands"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["sumInsured"]}
                                        dataIndex="ins_buy"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["insureTimes"]}
                                        dataIndex="ins_num"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["insuranceProfit"]}
                                        dataIndex="ins_profit"
                                    />
                                    <Table.Column
                                        align="center"
                                        title={this.props.language["profit"]}
                                        dataIndex="profit"
                                    />
                                </Table>
                            </Card>
                        </>
                    )}

                    {/* 玩家列表 */}
                    {this.props.type === "player" && (
                        <Table
                            dataSource={this.props.playerData}
                            pagination={false}
                            loading={this.props.loading}
                            scroll={{ x: true }}
                            rowKey={(record, index) => index}
                        >
                            <Table.Column
                                align="center"
                                title={this.props.language["playerName"]}
                                dataIndex="user_info"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["inClub"]}
                                dataIndex="club_info"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["inUnion"]}
                                dataIndex="union_info"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["inSuperUnion"]}
                                dataIndex="super_union_info"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["bought"]}
                                dataIndex="buy_in"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["poolEntryRate"]}
                                dataIndex="vpip"
                            />
                            <Table.Column
                                align="center"
                                title={this.props.language["handNumber"]}
                                dataIndex="hand_count"
                            />
                        </Table>
                    )}

                    {/* 手牌详情 */}
                    {this.props.type === "handCard" && (
                        <Spin spinning={this.props.loading}>
                            {this.props.handCardData.id && (
                                <>
                                    {/* OFC */}
                                    {this.props.selectedData.is_ofc && (
                                        <HandDetailOfc
                                            {...this.props}
                                            handCardData={this.props.handCardData}
                                            searchPlayer={{
                                                uid1: this.props.detailQueryParams.uid,
                                            }}
                                        />
                                    )}

                                    {/* NLH, 6+, PLO, AOF */}
                                    {!this.props.selectedData.is_ofc && (
                                        <HandDetail
                                            {...this.props}
                                            handCardData={this.props.handCardData}
                                            squidConf={this.props.selectedData.squid_conf}
                                            searchPlayer={{
                                                uid1: this.props.detailQueryParams.uid,
                                            }}
                                        />
                                    )}
                                </>
                            )}

                            {/* 暂无数据 */}
                            {!this.props.handCardData.id && (
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            )}
                        </Spin>
                    )}
                </div>
            </Modal>
        );
    }
}
